var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowStonks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.75C8.82812 1.75 8.5 1.42188 8.5 1C8.5 0.601562 8.82812 0.25 9.25 0.25H13C13.3984 0.25 13.75 0.601562 13.75 1V4.75C13.75 5.17188 13.3984 5.5 13 5.5C12.5781 5.5 12.25 5.17188 12.25 4.75V2.82812L8.26562 6.78906C7.98438 7.09375 7.49219 7.09375 7.21094 6.78906L4.75 4.32812L1.51562 7.53906C1.23438 7.84375 0.742188 7.84375 0.460938 7.53906C0.15625 7.25781 0.15625 6.76562 0.460938 6.48438L4.21094 2.73438C4.49219 2.42969 4.98438 2.42969 5.26562 2.73438L7.75 5.19531L11.1719 1.75H9.25Z",
    fill: "#B43A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStonks);
export default __webpack_public_path__ + "static/media/arrow-stonks.ef04a6439c09e44fa7d4effd860a0cdd.svg";
export { ForwardRef as ReactComponent };